import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import css from './bfm.css';

let SendEmailForm = (props) => {

  const { handleSubmit, onClose, renderTextField, bankfeeds } = props;
  const { sending, sent, error } = bankfeeds;

  let sendButtonInfo = 'Send';
  if (sending) sendButtonInfo = <CircularProgress size={24} />;
  if (sent) sendButtonInfo = <CheckIcon size={24} />;

  const message = [
    'To Share access to the Bank feed management window with another person, we will send an email to them with the information they need to log in.',
    ' The first section of the Email is editable for any personalised information you want to provide.',
    <br />,
    'If the user already has a Reckon account, they can use this to log in, otherwise an account will be automatically created and sent to them.'
  ];

  const emailTemp = [
    'Access to the BankFeed Management Window is provided through the Reckon Portal. Please click here to set up your login, using this email address: Please click here to set up your login, using this email address: Example@reckon.com. You will be required to provide and confirm a password in this window.',
    <br />,
    'Once logged in, you will be able to Add or Authorise the required Bank Feeds.',
    <br />, <br />,
    'After setting up your account, you will be able to login directly at the following link:',
    <br />,
    'https://bankdata-web.reckon.com/book/exampleLink',
    <br />, <br />,
    'Reckon BankData'
  ]

  return (
    <form className={css.wrapper} onSubmit={handleSubmit}>
      <DialogContent dividers="true">
        <DialogContentText id="scroll-dialog-description">
          {message}
        <div className={css.email}>
          <div className={css.emailBody}>
            <Field 
              className={[css.borderBottom, css.pl22].join(' ')}
              name="message"
              placeholder=" Message"
              component={renderTextField}
              fullWidth
              autoFocus
              multiline rows={7} />
          </div>
          <div className={css.emailFooter}>
            {emailTemp}
          </div>
        </div>
        <div className={css.red}>{error}</div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button type="submit" 
        disabled={sending || sent} 
        variant="contained" color="primary">
          {sendButtonInfo}
        </Button>
      </DialogActions>
    </form>
  )}

function mapStateToProps(state) {
  const { bankfeeds } = state;
  return { bankfeeds };
}

export default SendEmailForm = connect(
  mapStateToProps
)(
  reduxForm({
    form: 'sendEmailForm'
  })(SendEmailForm)
);



// WEBPACK FOOTER //
// ./src/components/FeedManagment/SendEmailForm.js